<template>
  <div class="wrap">
    <div class="userHader">
      <div class="userInforIcon">
        <img :src="sicon"
             alt
             v-if="sicon"/>
        <img src="../../assets/images/headericon.png"
             alt
             v-else/>
      </div>
      <div class="userInfor">

        <div class="userName" @click="updata">
          <span style="font-size:20px">{{ uName }}</span>
          <img src="../../assets/images/bianji.png"/>
        </div>
        <div class="userDate" @click="getMem">
          <span class="memberWrap">
            <img :src="memberType==1?vipGrPng:(memberType==2?vipQyPng:noMemberPng)">
            {{ memberType == 1 ? '个人会员' : memberType == 2 ? '企业会员' : '暂未开通会员' }}</span>
          <span v-if="memberType">{{ uMemberExpire|getTimes }}到期</span>
        </div>
      </div>

    </div>

    <div class="memberInfo">
      <div class="tabs">
        <div :class="`tab ${tabIndex==0?'tab-active':''}`" @click="()=>{this.tabIndex=0;}">个人会员</div>
        <div :class="`tab ${tabIndex==1?'tab-active':''}`" @click="()=>{this.tabIndex=1;}">企业会员</div>
      </div>
      <div class="infoWrap">
        <div v-if="tabIndex==0" class="ordinary">
          <img v-if="!memberType" class="bg" src="../../assets/images/member1_bg.png">
          <img v-if="memberType" class="bg" src="../../assets/images/member12_bg.png">
          <div class="btn" @click="pay">
            <span v-if="!memberType">立即开通</span>
            <span v-if="memberType">会员续费</span>
          </div>
          <div v-if="!memberType" class="info" @click="()=>{this.showQy=true;}"></div>
        </div>

        <div v-if="tabIndex==1" class="enterprise">
          <table class="info" border="0" cellspacing="0" cellpadding="0">
            <tr class="th">
              <th class="tc">套餐</th>
              <th class="jg">价格(人民币)</th>
              <th class="nr">内容</th>
            </tr>
            <tr class="row">
              <td class="tc">套餐一</td>
              <td class="jg">3000元/年</td>
              <td class="nr">包含1个账号</td>
            </tr>
            <tr class="row2">
              <td class="tc">套餐二</td>
              <td class="jg">8400元/年</td>
              <td class="nr">包含3个员工账号 平均2800元/账号</td>
            </tr>
            <tr class="row">
              <td class="tc">套餐三</td>
              <td class="jg">12500元/年</td>
              <td class="nr">包含5个员工账号 平均2500元/账号</td>
            </tr>
            <tr class="row2">
              <td class="tc">套餐四</td>
              <td class="jg">20000元/年</td>
              <td class="nr">包含10个员工账号 平均2000元/账号</td>
            </tr>
            <tr class="row2">
              <td class="tc">套餐五</td>
              <td class="jg">35000元/年</td>
              <td class="nr">包含20个员工账号 平均1750元/账号</td>
            </tr>
            <tr class="row2">
              <td class="tc">套餐六</td>
              <td class="jg">65000元/年</td>
              <td class="nr">包含50个员工账号 平均1300元/账号</td>
            </tr>
          </table>

          <div class="ent-phone">
            购买企业会员，需拨打电话13811612257
          </div>
        </div>
      </div>
    </div>
    <div class="menu" v-if="!showQy">
      <div class="item" v-for="(item,i) in list"
           :key="i"
           @click="toJump(item.link)">
        <i :class="`icon ${item.icon}`">
        </i>

        <span class="text">{{ item.text }}</span>
        <span class="menuNum"
              v-if="item.num">{{ item.num }}</span>
      </div>
    </div>

    <div v-if="showQy" class="qy-mask">
      <div class="content">
        <div class="close" @click="()=>{this.showQy=false}"></div>

        <div class="title">会员权益</div>

        <div class="list">
          <div class="item">
            <div class="num">01</div>
            <div class="contWrap">
              <div class="tit">600门好课免费畅学</div>
              <div class="cont">在会员期间内，畅学600门好课，会员课程 定期更新，提供您更多的选择</div>
            </div>
          </div>

          <div class="item">
            <div class="num">02</div>
            <div class="contWrap">
              <div class="tit">享受课程会员专属折扣</div>
              <div class="cont">购买线上培训课程可享受专属会员折扣价</div>
            </div>
          </div>

          <div class="item">
            <div class="num">03</div>
            <div class="contWrap">
              <div class="tit">新课尝鲜</div>
              <div class="cont">会员可优先免费学习当月新课，新课定期更新</div>
            </div>
          </div>

          <div class="item">
            <div class="num">04</div>
            <div class="contWrap">
              <div class="tit">专属客服</div>
              <div class="cont">会员可享受一对一专属客服服务，解答您的 各种疑问</div>
            </div>
          </div>

          <div class="item">
            <div class="num">05</div>
            <div class="contWrap">
              <div class="tit">会员标识</div>
              <div class="cont">带有会员特殊标识，彰显尊贵身份</div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import grxx from "../../assets/images/grxx.png";
import woyy from "../../assets/images/woyy.png";
import wdsc from "../../assets/images/wdsc.png";
import next from "../../assets/images/next.png";
import store from "../../store";

import noMemberPng from '../../assets/images/no_member.png';
import vipGrPng from '../../assets/images/vip_gr.png';
import vipQyPng from '../../assets/images/vip_qy.png';
import loginService from "../../plugin/extendFn/loginService";
import AppSetting from '../../AppSetting';

export default {
  data() {
    return {
      showQy: false,
      tabIndex: 0,
      uName: "",
      uGenre: "",
      memberType: 0, // 0非会员，1：个人会员，2：企业会员
      noMemberPng: noMemberPng,
      vipGrPng: vipGrPng,
      vipQyPng: vipQyPng,
      uMemberExpire: "",
      list: [
        {
          img: "grxx",
          text: "我的已购",
          next: next,
          link: "MyBuy",
          icon: "meYigou",
          num:0
        },
        // {img:grxx,text:'我的证书',next:next,link:'End'},
        {
          img: woyy,
          text: "我的预约",
          next: next,
          link: "Bespoke",
          icon: "meYuyue",
          num:0
        },
        {
          img: wdsc,
          text: "我的收藏",
          next: next,
          link: "Collection",
          icon: "meShoucang",
          num:0
        },
        // {
        //   img: wdsc,
        //   text: "账号分享",
        //   next: next,
        //   link: "ShareQRCode",
        //   icon: "shareQr",
        //   num:0
        // }
      ],
      ra_wxUser: null,
      sicon: "",
      numObj: {}
    };
  },
  props: {},
  filters: {
    getTimes(value) {
      if (!value) {
        return "";
      }
      return new Date(value).Format("yyyy.MM.dd");
    }
  },
  methods: {
    pay() {
      this.$router.push({
        name: "upay"
      });
    },
    getMem() {
      return;
      if (this.uGenre !== 2 && this.uGenre !== 3) {
        this.$router.push({
          name: "AddMem"
        });
      }
    },
   async getNum() {
      if(await loginService.isNotLogin())
      {
        return;
      }
      this.$postHttp(AppSetting.baseUrl + "/student/home", {
        id: this.ra_wxUser.uId
      }).then(res => {
        if (res.data.code == 0) {
          let numObj = res.data;
          this.list = [
            {
              img: "grxx",
              text: "我的已购",
              next: next,
              link: "MyBuy",
              icon: "meYigou",
              num: numObj.buyNum
            },
            // {img:grxx,text:'我的证书',next:next,link:'End'},
            {
              img: woyy,
              text: "我的预约",
              next: next,
              link: "Bespoke",
              icon: "meYuyue",
              num: numObj.appointmentNum
            },
            {
              img: wdsc,
              text: "我的收藏",
              next: next,
              link: "Collection",
              icon: "meShoucang",
              num: numObj.columnNum
            },
            // {
            //   img: wdsc,
            //   text: "账号分享",
            //   next: next,
            //   link: "ShareQRCode",
            //   icon: "shareQr",
            //   num:0
            // }
          ];
          // this.list = res.data.data;
        }
      });
    },
    async updata() {
      let re_wxUser =await loginService.getLoginUser()
      if (!re_wxUser) {
        this.login();
      }
      else{
        this.$router.push({
          name: "UserInfor"
        });
      }
    },
    login () {
      loginService.login(this.$router)
      .then(loginUser=>{
        this.ra_wxUser=loginUser
      })
    },
    outLoader() {
      loginService.logout();
      this.$router.push({
        name: "Login"
      });
    },
    async toJump(link) {
      this.ra_wxUser=await loginService.getLoginUser();
      if (await loginService.isNotLogin()) {
          this.login();
      } else {
        this.$router.push({
          name: link,
          meta:{
            title: '我的已购'
          }
        });
      }
    },
    async info() {
      if(await loginService.isNotLogin())
      {
        return;
      }
      this.$postHttp(AppSetting.baseUrl + "/student/info", {
        id: this.ra_wxUser.uId
      }).then(async res => {
        if (res.data.code == 0) {
          this.ra_wxUser = res.data.student;
          await loginService.setLoginUser(res.data.student)
          let uMemberExpire = this.ra_wxUser.uMemberExpire;
          let now = Date.now();
          this.uName = this.ra_wxUser.uName;
          this.uGenre = this.ra_wxUser.uGenre;


          this.uMemberExpire = this.ra_wxUser.uMemberEnd;

          this.memberType = this.ra_wxUser ? this.ra_wxUser.uMemberType : 0;

          if (now > uMemberExpire) {
            this.uGenre = 1;
          }
          this.sicon = this.ra_wxUser.uIcon;
        }
      });
    }
  },
  computed: {},
  async mounted() {
    setTimeout(() => {
      document.title = "我的";
    }, 300)
    this.ra_wxUser=await loginService.getLoginUser();
    console.log("this.ra_wxUser >>>> ",this.ra_wxUser)
    this.$waiting.hide();
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    this.info();
    this.getNum();
  },

};
</script>
<style scoped lang="scss">
.wrap {
  min-height: 100vh;
  background: #f4f5f4;

  .userHader {
    // overflow: hidden;
    font-size: 0.34rem;
    color: #fff;
    background: url("../../assets/images/bg.png") no-repeat;
    background-size: 100% 100%;
    padding: 0rem 0.3rem;
    box-sizing: border-box;
    padding-top: 0.21rem;
    padding-bottom: 1rem;
    //position: relative;
    //margin-bottom: 1rem;
    height: 2.7rem;
  }

  .userInforIcon {
    float: left;
    width: 1.2rem;
    height: 1.2rem;
    border-radius: 50%;

    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }

  .userInfor {
    padding-top: 0.15rem;
    padding-left: 0.3rem;
    width: 5.38rem;
    float: left;

    .huiyuan {
      display: inline-block;
      width: 0.32rem;
      height: 0.36rem;
      background: url("../../assets/images/vip.png") no-repeat;
      background-size: 100% 100%;
      position: relative;
      top: 0.05rem;
    }

    .updata {
      display: inline-block;
      width: 0.32rem;
      height: 0.36rem;
      background: url("../../assets/images/bianji.png") no-repeat;
      background-size: 100% 100%;
    }

    .userName {
      img {
        height: .26rem;
        max-width: 100%;
      }
    }
  }

  .userDate {
    font-size: 0.26rem;
    //letter-spacing: 2px;
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .sel {
    height: 1.3rem;
    line-height: 1.3rem;
    background: #fff;
    color: #333;
    font-size: 0.32rem;
    padding: 0px 0.33rem;
    margin-top: 0.29rem;
    position: relative;

    .sel-right {
      float: right;
    }

    .selIcon {
      position: absolute;
      right: 0.3rem;
      top: 50%;

      width: 0.18rem;
      height: 0.38rem;
      background: url("../../assets/images/jiantou-.png") no-repeat;
      background-size: 100% 100%;
      margin-top: -0.19rem;
    }

    .ban {
      position: relative;
      padding-top: 0.75rem;
      line-height: 1.9rem;
      font-size: 0.24rem;
      color: #666666;
      margin-left: 0.59rem;
    }

    .zuoyeIcon {
      position: absolute;
      top: 0.23rem;
      left: -2px;
      display: block;

      width: 0.52rem;
      height: 0.52rem;
      background: url("../../assets/images/zuoye.png") no-repeat;
      background-size: 100% 100%;
    }

    .kaoshi {
      background: url("../../assets/images/kaoshi.png") no-repeat;
      background-size: 100% 100%;
    }
  }

  .selList {
    margin-top: 0.29rem;

    .sel {
      margin-top: 0px;
      border-bottom: 0.01rem solid #f4f5f4;
    }
  }

  .userinfo {
    display: flex;
    width: 7.5rem;
    height: 1.6rem;
    background: url("../../assets/images/meBg.png") no-repeat;
    -webkit-background-size: 100%;
    background-size: 100%;
    margin-bottom: 0.2rem;
    padding-left: 0.33rem;
    padding-top: 0.22rem;
    box-sizing: border-box;

    img {
      width: 1.2rem;
      height: 1.2rem;
      margin-right: 0.19rem;
    }

    > div {
      color: #ffffff;

      p:nth-of-type(1) {
        font-size: 0.4rem;
      }

      p:nth-of-type(2) {
        font-size: 0.32rem;
      }
    }
  }

  ul {
    padding-left: 0.32rem;
    box-sizing: border-box;
    background: #ffffff;
    border-bottom: 1px solid #e6e6e6;
    border-top: 1px solid #e6e6e6;

    li {
      width: 7.19rem;
      height: 1rem;
      display: flex;
      font-family: PingFang-SC-Medium;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #e6e6e6;
      padding-right: 0.39rem;
      box-sizing: border-box;
      font-size: 0.32rem;
      color: #333333;

      span {
        display: flex;
        align-items: center;

        img {
          margin-right: 0.14rem;
          width: 0.41rem;
        }
      }

      > img {
        width: 0.48rem;
        /*height: 0.35rem;*/
      }
    }

    li:nth-of-type(3) {
      border: none;
    }
  }

  .outuser {
    width: 7.5rem;
    margin-top: 0.4rem;
    height: 1rem;
    background: #ffffff;
    font-size: 0.32rem;
    font-family: 微软雅黑;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid #e6e6e6;
    border-top: 1px solid #e6e6e6;
    position: absolute;
    bottom: 1.5rem;
    left: 0;
  }
}

.memberWrap {
  display: flex;
  align-items: center;

  img {
    max-width: 0.26rem;
    max-height: 100%;
    margin-right: 0.1rem;
  }
}

* {
  box-sizing: border-box;
}

.memberInfo {
  padding: 0.1rem 0.45rem;
  margin-top: -0.7rem;

  .tabs {
    border-radius: .1rem;
    background-color: #ffffff;
    font-size: .32rem;

    display: flex;
    justify-content: space-between;
    text-align: center;

    color: #C3A160;

    .tab {
      flex: 1;
      height: .8rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border: .01rem solid #D2AC57;

      &-active {
        background: linear-gradient(-90deg, #FDC45A 0%, #FADCA0 100%);
        color: #623B01;
        border: 0;
      }
    }

    :first-child {
      border-radius: .1rem 0 0 .1rem;
      border-right: 0;
    }

    :last-child {
      border-radius: 0 .1rem .1rem 0;
      border-left: 0;
    }
  }

  .infoWrap {
    margin-top: .2rem;

    .ordinary {
      position: relative;
      height: 3rem;

      .bg {
        width: 6.6rem;
        height: 3rem;
      }

      .btn {
        width: 2.4rem;
        height: .7rem;
        background: linear-gradient(-90deg, #FDC45B 0%, #FADB9F 100%);
        border-radius: .1rem;

        font-size: .32rem;
        font-family: SourceHanSansCN;
        font-weight: 500;
        color: #623B01;
        line-height: .7rem;
        text-align: center;

        position: absolute;

        right: .3rem;
        bottom: .3rem;
      }

      .info {
        width: 2.6rem;
        height: .4rem;
        /*background: red;
        opacity: .4;*/

        position: absolute;
        right: .3rem;
        top: .4rem;
      }
    }

    .enterprise {

      font-size: .24rem;

      .info {
        border-radius: .1rem;
        width: 100%;
        background: #FFFFFF;
        box-shadow: .03rem .04rem .09rem .01rem rgba(217, 217, 217, 0.5);

        td, th {
          height: .7rem;
          text-align: center;
        }

        .th {
          background: #61C5FF;
          color: #ffffff;
        }

        .nr {
          width: 2.2rem;
        }

        .row {
          color: #666666;
        }

        .row2 {
          background: rgba(220, 242, 255, 1);
          color: #666666;
        }
      }

      .ent-phone {
        font-size: .26rem;
        font-family: SourceHanSansCN;
        font-weight: 500;
        color: #C3A160;
        height: .8rem;
        line-height: .8rem;
        text-align: center;

        background: #ffffff;
        margin-top: .2rem;
      }
    }
  }
}


.menu {

  margin-top: .2rem;

  .item {
    display: flex;
    align-items: center;

    height: .9rem;

    padding: 0 .45rem;

    margin-bottom: .1rem;

    position: relative;

    .icon {
      height: .36rem;
      width: .36rem;
      max-width: 100%;
      margin-right: 0.4rem;
      position: relative;
      z-index: 3;
    }

    .text {
      font-size: .3rem;
      font-family: SourceHanSansCN;
      font-weight: 500;
      color: #333333;
    }
  }

  .menuNum {
    display: inline-block;
    border: 0.01rem solid rgba(255,0,0,.3);
    border-radius: 50%;
    color: #ff0000;
    font-size: 0.18rem;
    width: 0.35rem;
    height: 0.35rem;
    text-align: center;
    line-height: 0.35rem;
    position: absolute;
    top: 0.1rem;
    left: 0.7rem;
    z-index: 1;
  }

  .meYuyue {
    background: url("../../assets/images/yuyue.png") no-repeat;
    background-size: 100% 100%;
  }

  .meYigou {
    background: url("../../assets/images/yigou.png") no-repeat;
    background-size: 100% 100%;
  }

  .meShoucang {
    background: url("../../assets/images/3.png") no-repeat;
    background-size: 100% 100%;
  }

  .shareQr{
    background: url("../../assets/images/shareQr.png") no-repeat;
    background-size: 100% 100%;
  }
  .item:nth-child(1) {
    background-color: rgba(13, 180, 255, 0.08);
  }

  .item:nth-child(2) {
    background-color: rgba(85, 153, 64, 0.08);
  }

  .item:nth-child(3) {
    background-color: rgba(245, 188, 113, 0.08);
  }
}


.qy-mask {
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background: rgba(0, 0, 0, .5);
  position: fixed;

  .content {
    position: relative;
    margin: 1.5rem .45rem;
    background: url("../../assets/images/qy_bg.png") no-repeat;
    background-size: 100% 100%;

    width: 6.6rem;
    height: 9rem;
  }

  .close {
    background: url("../../assets/images/close2.png") no-repeat;
    background-size: 100% 100%;
    width: .64rem;
    height: .64rem;
    position: absolute;
    right: -.3rem;
    top: -.3rem;
  }

  .title {
    margin-top: .6rem;
    font-size: .44rem;
    text-align: center;
    font-family: SourceHanSansCN;
    font-weight: 500;
    color: #FFC160;
    line-height: 81px;
    text-shadow: -2px 0px 5px rgba(23, 20, 37, 0.51);
  }

  .list {
    .item {
      display: flex;
      padding: 0 .4rem;
      margin-top: .3rem;

      .num {
        background: url("../../assets/images/num_bg.png") no-repeat;
        background-size: 100% 100%;
        width: .48rem;
        height: .48rem;

        display: flex;
        align-items: center;
        justify-content: center;

        font-size: .22rem;
        font-weight: bold;
        color: #D2A167;

        flex-shrink: 0;
      }

      .contWrap {
        margin-left: .15rem;

        .tit {
          font-size: .32rem;
          font-family: SourceHanSansCN;
          font-weight: 500;
          color: #D2A167;
        }

        .cont {
          font-size: .26rem;
          font-family: SourceHanSansCN;
          font-weight: 400;
          color: #D2A167;
          line-height: .36rem;
        }
      }
    }
  }
}
.alarm{
  font-size: 10px;
    color: red;
    float: left;
    position: relative;
    top: -10px;
    left: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/me/index.vue